import { useMsal } from "@azure/msal-react";
import { InteractionRequiredAuthError } from "@azure/msal-browser";
import { useEffect, useState } from "react";
import { loginRequest } from "../msalConfig";
import './SessionExpiredModal.css';

export default function SessionExpiredModal() {
  const { instance, accounts } = useMsal();
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (!accounts.length) return;

    const CHECK_INTERVAL_MS = 30 * 1000; // Check every 30 seconds

    const checkToken = async () => {
      try {
        await instance.acquireTokenSilent({
          ...loginRequest,
          account: accounts[0],
        });
      } catch (e) {
        if (e instanceof InteractionRequiredAuthError) {
          setShow(true);
        }
      }
    };

    const interval = setInterval(checkToken, CHECK_INTERVAL_MS);
    return () => clearInterval(interval);
  }, [accounts, instance]);

  if (!show) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-card">
        <div className="modal-icon">🔒</div>
        <h2>Session Expired</h2>
        <p>Your session has expired. Please sign in again to continue.</p>
        <button
          className="btn-primary"
          onClick={() => instance.loginRedirect(loginRequest)}
        >
          Sign In Again
        </button>
      </div>
    </div>
  );
}
